import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { Link, useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { toastAlert } from "../../lib/toastAlert";

//api
import { addstake } from "../../actions/users";
import { MenuItem, InputLabel } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import isEmpty from "lib/isEmpty";
import Web3 from "web3";
import UPRO_ABI from "../whitelist/UPRO_ABI.json";

//styles
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  textDanger: {
    color: "#f32828",
  },

  btnPrimary: {
    backgroundColor: "#b462c5",
    color: "#ffffff !important",
    padding: "7px 15px",
    fontSize: "12px",
    fontWeight: "700",
  },
};

// toaster config
toast.configure();
let toasterOption = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const initialFormValue = {
  amount: "",
  address: "",
  deviceId: "",
};

const useStyles = makeStyles(styles);

export default function Categoryadd(props) {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();

  //state
  const [toched, setToched] = useState({});
  const [formValue, setFormValue] = useState(initialFormValue);
  const { amount, deviceId, address } = formValue;
  const [membercode, setMemberCode] = useState("");

  //function
  const onChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } };
    setFormValue(formData);
    console.log(formValue);
    if (id == "address") {
      membercodeget(value);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let formData = { ...formValue, ...{ [name]: value } };
    setFormValue(formData);
  };

  const handleFormSubmit = async (e) => {
    //console.log("saran");
    e.preventDefault();
    if (
      isEmpty(address) ||
      isEmpty(amount) ||
      isEmpty(membercode) ||
      isEmpty(deviceId) ||
      amount <= 0
    ) {
      toastAlert("error", "Enter All the fields");
    } else {
      let reqData = {
        address: address,
        amount: amount,
        membercode: membercode,
        deviceId: deviceId,
      };
      console.log(reqData);
      const { status, loading, error, message } = await addstake(reqData);
      console.log(error, "---error");
      if (status == "success") {
        toastAlert("success", message, "staking");
        history.push("/staking");
      } else {
        toastAlert("error", error.error, "staking");
      }
    }
  };

  async function membercodeget(address) {
    try {
      if (!isEmpty(address)) {
        var web3 = new Web3("https://mainnet-rpc.ultraproscan.io/");
        let contractAddr = "0x5F581cbbE5D96B19A19D3c281D541Fe94cd255FD";
        var Contract = new web3.eth.Contract(UPRO_ABI, contractAddr);
        address = Web3.utils.toChecksumAddress(address);
        var stakedetails = await Contract.methods.stakes(address).call();
        let memebercode = stakedetails[1];
        console.log(stakedetails, "--stakedetails");

        if (!isEmpty(stakedetails) && memebercode > 0) {
          setMemberCode(memebercode);
        } else {
          setMemberCode("");
        }
      } else {
        setMemberCode("");
      }
    } catch (err) {
      setMemberCode("");
    }
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <form
              className={classes.form}
              noValidate
              onSubmit={handleFormSubmit}
            >
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>Add Staking</h4>
              </CardHeader>

              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Enter Address"
                      id="address"
                      name="address"
                      value={address}
                      onChange={onChange}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  {/* <GridItem xs={12} sm={12} md={4}>
                    <div className="custom_select">
                      <InputLabel id="demo-controlled-open-select-label">
                        Month
                      </InputLabel>
                      <Select
                        className="d-block"
                        onChange={handleChange}
                        name="month"
                      >
                        {monthArr?.map((item) => {
                          return <MenuItem value={item}>{item}</MenuItem>;
                        })}
                      </Select>
                    </div>
                  </GridItem> */}

                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="amount"
                      onChange={onChange}
                      id="amount"
                      name="amount"
                      value={amount}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="App Id"
                      onChange={onChange}
                      id="deviceId"
                      name="deviceId"
                      value={deviceId}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Member Code"
                      //   onChange={onChange}
                      id="membercode"
                      name="membercode"
                      value={membercode}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="primary" type="submit">
                  Add
                </Button>
              </CardFooter>
            </form>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
